import React from 'react';

/**
 * The three headline training figures, shown above the Official Training
 * Report on both the Overview and the Training Hours tab — one component so
 * the two surfaces cannot become different-looking copies.
 *
 * The numbers come from utils/trainingStats.js, so the cards only render.
 * Scope is deliberately wider than the report below them: every person with a
 * record, including non-audit grades and former staff — hence the sub-labels,
 * which are the reason the two sets of numbers legitimately differ.
 */
const TrainingStatCards = ({ stats }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-6">
      <p className="text-sm text-blue-700 font-medium">Total Training Hours</p>
      <p className="text-3xl font-bold text-blue-900">{stats.totalHours.toFixed(1)}</p>
      <p className="text-xs text-blue-600 mt-1">
        Mandatory: {stats.totalMandatoryHours.toFixed(1)} | Non-mandatory: {stats.totalNonMandatoryHours.toFixed(1)} | External: {stats.totalExternalHours.toFixed(1)}
      </p>
      <p className="text-xs text-blue-500 mt-0.5">All staff, incl. non-audit grades</p>
    </div>

    <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-lg p-6">
      <p className="text-sm text-green-700 font-medium">Participants</p>
      <p className="text-3xl font-bold text-green-900">{stats.uniquePeople}</p>
      <p className="text-xs text-green-600 mt-1">Unique staff with records in period</p>
    </div>

    <div className="bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-lg p-6">
      <p className="text-sm text-orange-700 font-medium">Avg Hours/Person</p>
      <p className="text-3xl font-bold text-orange-900">{stats.avgHoursPerPerson.toFixed(1)}</p>
      <p className="text-xs text-orange-600 mt-1">Per participant, incl. non-audit grades</p>
    </div>
  </div>
);

export default TrainingStatCards;
